export class EditSpecialFlagFormData {
  id?: number;
  name: string;
  icon: File;
}
